import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "navbar-img-override"
};
const _hoisted_2 = {
  class: "image-slot"
};
const _hoisted_3 = {
  class: "hidden-lg-and-up"
};
import { ref, inject, watch, computed } from 'vue';
import { useRoute } from 'vue-router';
import NavBarMenu from './NavBarMenu.vue';
import NavBarOptions from './NavBarOptions.vue';
import NavMenuOverlay from './NavMenuOverlay.vue';
import { Picture } from '@element-plus/icons-vue';
import { MenuBars } from "@/assets/SVGs/AutoTuneIconLib";
import * as modalOps from "@/composables/modal.js";
import MiniBanner from '@/components/MiniBanner.vue';
import { currentBP } from '@/composables/windowWatcher';

// Data

export default {
  __name: 'NavBar',
  setup(__props) {
    const navbar = ref(null);
    const navOverlayVisible = ref(false);
    const user = inject('user');
    const cart = inject('cart');
    const route = useRoute();

    // Methods

    const openNavOverlay = () => {
      navOverlayVisible.value = true;
      modalOps.registerModal('navOverlay');
    };
    const closeNavOverlay = () => {
      navOverlayVisible.value = false;
      modalOps.unregisterModal('navOverlay');
    };
    const showBadge = computed(() => {
      return route.name !== 'Checkout' && cart.cartContainsItems || user.hasAvailableUpgrades;
    });
    const clearFocus = () => {
      if (document.activeElement && navbar.value?.$el?.contains(document.activeElement)) {
        document.activeElement.blur();
      }
    };

    // If the screen size changes to lg or xl, reset the navigation overlay
    watch(currentBP, newVal => {
      if (newVal === 'lg' || newVal === 'xl') {
        closeNavOverlay();
      }
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_image = _resolveComponent("el-image");
      const _component_router_link = _resolveComponent("router-link");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_badge = _resolveComponent("el-badge");
      const _component_el_row = _resolveComponent("el-row");
      const _component_FocusTrap = _resolveComponent("FocusTrap");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_row, {
        id: "acct-app-header",
        ref_key: "navbar",
        ref: navbar,
        onMouseleave: _cache[0] || (_cache[0] = () => clearFocus())
      }, {
        default: _withCtx(() => [_createVNode(MiniBanner), _createVNode(_component_el_row, {
          class: "navbar",
          align: "middle",
          justify: "center",
          id: "main-nav-bar"
        }, {
          default: _withCtx(() => [_createVNode(_component_FocusTrap, {
            horizontalControls: "",
            disableTabLock: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_row, {
              class: "navbar-content",
              align: "middle",
              justify: "space-between"
            }, {
              default: _withCtx(() => [_createVNode(_component_router_link, {
                to: {
                  name: 'Home'
                }
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_image, {
                  alt: "Antares Audio Technologies logo",
                  src: "https://antares-web-frontend.sfo3.cdn.digitaloceanspaces.com/company-logo/AutoTune_white_logo_with_new_teal_wave.webp",
                  style: {
                    "height": "100%"
                  }
                }, {
                  error: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_icon, {
                    size: 30
                  }, {
                    default: _withCtx(() => [_createVNode(_unref(Picture))]),
                    _: 1
                  })])]),
                  _: 1
                })])]),
                _: 1
              }), _createVNode(NavBarMenu, {
                class: "hidden-md-and-down"
              }), _createVNode(NavBarOptions, {
                class: "hidden-md-and-down"
              }), showBadge.value ? (_openBlock(), _createBlock(_component_el_badge, {
                key: 0,
                class: "hidden-lg-and-up",
                type: "primary",
                "is-dot": "",
                offset: [-5, 5]
              }, {
                default: _withCtx(() => [_createVNode(_component_el_button, {
                  type: "primary",
                  size: "large",
                  circle: "",
                  class: "gray-base",
                  onClick: openNavOverlay,
                  "data-testid": "navMenuButton",
                  icon: _unref(MenuBars)
                }, null, 8, ["icon"])]),
                _: 1
              })) : (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                type: "primary",
                size: "large",
                circle: "",
                class: "hidden-lg-and-up gray-base",
                onClick: openNavOverlay,
                "data-testid": "navMenuButton",
                icon: _unref(MenuBars)
              }, null, 8, ["icon"]))]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 512), _createElementVNode("div", _hoisted_3, [_createVNode(NavMenuOverlay, {
        onClose: closeNavOverlay,
        visible: navOverlayVisible.value
      }, null, 8, ["visible"])])], 64);
    };
  }
};